import { Card } from '@material-ui/core';
import styled from 'styled-components';

export const PageCard = styled(Card)`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 198px);
  padding: ${({ theme }) => theme.spacing(10, 6, 6)};
`;
